const formatNumberEuropean = (number) => {
    if(!number){
        return Number(0).toLocaleString('hr-HR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    return number.toLocaleString('hr-HR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}


export { formatNumberEuropean };